import React, { Suspense,useEffect ,useState} from "react";
import "./Terms_and_condition.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { 
  useHistory,
} from "react-router-dom";
import {
  Form,  
} from "reactstrap";
import Loading from "../../components/Loading";
import Footer from "../../DefaultLayout/Footer";
import DashboardNavbar from "../../DefaultLayout/DashboardNavbar.js";
import { connect,useSelector } from "react-redux";
import { BsCheck2 } from "react-icons/bs";
import { useDispatch } from "react-redux";
import LoggedHeader from "../../DefaultLayout/LoggedHeader";
import { getContentDetails } from "../../actions/cmsAction";
import { TermsTableLoader } from "../../components/DashboardLoader.js";

const Terms_and_condition = (props) => {
  const { frontLabelsName } = props.label;
  let isSubscribing = localStorage.getItem("isSubscribing");
    const history = useHistory();
    const dispatch = useDispatch();

  const currentLanguageCode = localStorage.getItem("prevLangFront") 
    const [fetchLoading, setFetchLoading] = useState(true);
    const [errCheckbox,setErrCheckbox]= useState('')
      const [termsCheckbox, setTermsCheckbox] = useState(false);
     const cms = useSelector((state) => state.cmsPages.cms);
      const data = cms?.data[0]?.content;



   useEffect(() => {
     props.getContentDetails(isSubscribing === "true" ?'subscriber-term-and-condition':"non-subscriber-terms-and-condition", currentLanguageCode).then((res) => {
      setFetchLoading(false)
        });
  
      
    }, [currentLanguageCode]);

    const handleNext=()=>{

  
      if (termsCheckbox === false) {
        setErrCheckbox(frontLabelsName
          ? frontLabelsName.filter(
              (e) => e.key == "lbl_terms_&_agreement"
            ).length > 0
            ? frontLabelsName.filter(
                (e) => e.key == "lbl_terms_&_agreement"
              )[0]["value"] || "lbl_terms_&_agreement"
            : "lbl_terms_&_agreement"
          : "lbl_terms_&_agreement")  ;
      }else{
        setErrCheckbox("") 
        dispatch({
          type:"SET_STEP",
          payload:{step:1,status:true}
       });
       localStorage.setItem("currentStepIndex", 1)
        history.push("/register-basic-info");
      }

    }

  return (
    <React.Fragment>
      <Suspense fallback={<Loading />}>
        <LoggedHeader />

        <DashboardNavbar/>
      </Suspense>
      <div className="container">
        <div className="main-term-condition list-Renterl22 term-condition">
          <div className="trams-condition-box  d-flex">
            <div className="row flex-grow-class" >
              <div className="col-lg-9 col-md-12 custom-flex-made">
                <Form className="st-fl-hg-trem">
                  <div className="">
                    <h2 className="custom-h2-size text-center">
                      {frontLabelsName
                        ? frontLabelsName.filter(
                            (e) => e.key == "lbl_term_condition"
                          ).length > 0
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_term_condition"
                            )[0]["value"] || "lbl_term_condition"
                          : "lbl_term_condition"
                        : "lbl_term_condition"}
                    </h2>
                    <div className={isSubscribing === "true" ? "term-desc-contentxx" : "term-desc-content"}>
                      <p className="set-pdd-trms">
                           
                       {!fetchLoading &&  data && (
                              <div dangerouslySetInnerHTML={{ __html: data }} />
                            )}
                 
                 {fetchLoading && <TermsTableLoader />}  
                      </p>
                   
                    </div>
                    <div className="agreement-style mt-3 align-items-center">
                <input
                  type="checkbox"
                  id="agreement"
                  checked={termsCheckbox}
                  onChange={(e) => setTermsCheckbox(e.target.checked)}
                  className="checkbox-cursor"
                />
                <label htmlFor="agreement" className="ps-2">
                  {frontLabelsName
                    ? frontLabelsName.filter(
                        (e) => e.key == "lbl_agree_term_condition"
                      ).length > 0
                      ? frontLabelsName.filter(
                          (e) => e.key == "lbl_agree_term_condition"
                        )[0]["value"] || "lbl_agree_term_condition"
                      : "lbl_agree_term_condition"
                    : "lbl_agree_term_condition"}
                </label>
              </div>
              {errCheckbox && (
                <span className="invalid_span">{errCheckbox}</span>
              )}
                  </div>

                  <div class="buton-left-basic-info1 float-right-add mb-4">
               
                      <button class="btn btn-secondary no-focus" type="button" onClick={handleNext}>
                        {frontLabelsName
                          ? frontLabelsName.filter((e) => e.key == "lbl_next")
                              .length > 0
                            ? frontLabelsName.filter((e) => e.key == "lbl_next")[0][
                                "value"
                              ] || "lbl_next"
                            : "lbl_next"
                          : "lbl_next"}
                        <span>
                          <svg
                            stroke="currentColor"
                            fill="currentColor"
                            stroke-width="0"
                            viewBox="0 0 16 16"
                            height="1em"
                            width="1em"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                            ></path>
                          </svg>
                        </span>
                      </button>
              
                  </div>
                </Form>
              </div>
              <div className="col-lg-3 col-md-12">
                <div className="black-main">
                  <div className="list-black-main">
                    <ul>
                      <li>
                        <div className="custom-set-arr">
                          <span className="yellow-cricle">
                            <BsCheck2 />
                          </span>
                          <p>
                            {frontLabelsName
                              ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_term_condition"
                                ).length > 0
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_term_condition"
                                  )[0]["value"] || "lbl_term_condition"
                                : "lbl_term_condition"
                              : "lbl_term_condition"}
                          </p>
                        </div>
                      </li>
                      <li>
                        <div className="custom-set-arr">
                          <span className="gray-cricle">2</span>
                          <p>
                            {frontLabelsName
                              ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_basic_info"
                                ).length > 0
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_basic_info"
                                  )[0]["value"] || "lbl_basic_info"
                                : "lbl_basic_info"
                              : "lbl_basic_info"}
                          </p>
                        </div>
                      </li>
                      <li>
                        <div className="custom-set-arr">
                          <span className="gray-cricle">3</span>
                          <p>
                          {
                          frontLabelsName
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_tenant_list"
                            ).length > 0
                            ? frontLabelsName.filter(
                                (e) => e.key == "lbl_tenant_list"
                              )[0]["value"] || "lbl_tenant_list"
                            : "lbl_tenant_list"
                          : "lbl_tenant_list"}
                          </p>
                        </div>
                      </li>
                      <li>
                        <div className="custom-set-arr">
                          <span className="gray-cricle">4</span>
                          <p>
                          {frontLabelsName
                              ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_tenant_profile"
                                ).length > 0
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_tenant_profile"
                                  )[0]["value"] || "lbl_tenant_profile"
                                : "lbl_tenant_profile"
                              : "lbl_tenant_profile"}
                          </p>
                        </div>
                      </li>
                        {isSubscribing === "true" &&   <li>
                        <div className="custom-set-arr">
                          <span className="gray-cricle">5</span>
                          <p>
                          {frontLabelsName
                              ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_payment"
                                ).length > 0
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_payment"
                                  )[0]["value"] || "lbl_payment"
                                : "lbl_payment"
                              : "lbl_payment"}
                          </p>
                        </div>
                      </li>}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Suspense fallback={<Loading />}>
        <Footer />
      </Suspense>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({
  label: state.language,
});
export default connect(mapStateToProps, {getContentDetails})(Terms_and_condition);
